<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-snackbar v-model="snackbar" top right dark color="green darken-1">
      {{ snackbarMsg }}
    </v-snackbar>

    <StaffNav class="hideOnPrint" />
    <v-row class="hideOnPrint">
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-stepper v-model="e6" vertical>
                  <v-stepper-step :complete="e6 > 1" step="1" editable>
                    Section 1:
                    <small>Disability and Functional Impairment</small>
                  </v-stepper-step>

                  <v-stepper-content step="1">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="4" class="pl-6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.newDate"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.newDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-autocomplete
                            v-model="item.newClientName"
                            label="Client Name"
                            :items="clients"
                            item-text="Name"
                            item-value="Name"
                            @change="onSelectClient(clients)"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-autocomplete
                            v-model="item.newProgram"
                            label="Program"
                            :items="units"
                            item-text="Name"
                            item-value="Name"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="mb-2 font-weight-bold">
                            What physical and/or mental condition(s) (e.g.,
                            Autism Spectrum Disorder Intellectual Disability,
                            Cerebral Palsy, Bipolar Disorder, Fetal Alcohol
                            Syndrome, etc.) has this individual been diagnosed
                            with?
                          </div>
                          <v-textarea
                            v-model="item.newConditions"
                            label="Physical and Mental Condidtions"
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="mb-2 font-weight-bold">
                            What areas of functioning (i.e., receptive and
                            expressive language, social and interpersonal;
                            self-care; academic and occupational; cognitive;
                            health and wellness; etc.) area affected by this
                            individuals's physical and/or mental condition and
                            in what ways (e.g., "Kyle is non-verbal and is
                            therfore unable to express his needs verbally")?
                          </div>
                          <v-textarea
                            v-model="item.newFunctions"
                            label="Affected Functions"
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 2"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 2" step="2" editable>
                    Section 2:
                    <small>Person-Centered Support Plan (PCSP)</small>
                  </v-stepper-step>

                  <v-stepper-content step="2">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="6">
                          <div>
                            I Read the Client's Person-Centered Support Plan
                            <template v-if="!annualDocs || Object.keys(annualDocs).length === 0">
                              <v-alert
                                dense
                                text
                                type="info"
                                class="ml-2 d-inline-block"
                              >
                                No annual documents available
                              </v-alert>
                            </template>
                            <annual-docs-dialog
                              v-else
                              v-model="showAnnualDocsDialog"
                              :annual-docs="annualDocs"
                            />
                            <p v-if="annualDocs">Annual Documents Expiration Date: {{annualDocsExpirationDate}}</p>
                          </div>
                          <v-checkbox
                            label="Signature"
                            v-model="item.newReadPCSP"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <div>I Read the Client's Support Strategies</div>
                          <v-checkbox
                            label="Signature"
                            v-model="item.newReadCSS"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold text-center">
                            Please list each of the individual's goals and the
                            support item(s) for each goal
                          </div>
                        </v-col>

                        <v-col cols="12" sm="6" class="mt-2 mb-2 pa-6">
                          <v-card class="pa-6">
                            <v-text-field
                              class="font-weight-bold"
                              v-model="item.newG1"
                              label="Goal 1"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 1"
                              v-model="item.newG1S1"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 2"
                              v-model="item.newG1S2"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 3"
                              v-model="item.newG1S3"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 4"
                              v-model="item.newG1S4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" class="mt-2 mb-2 pa-6">
                          <v-card class="pa-6">
                            <v-text-field
                              class="font-weight-bold"
                              v-model="item.newG2"
                              label="Goal 2"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 1"
                              v-model="item.newG2S1"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 2"
                              v-model="item.newG2S2"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 3"
                              v-model="item.newG2S3"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 4"
                              v-model="item.newG2S4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" class="mt-2 mb-2 pa-6">
                          <v-card class="pa-6">
                            <v-text-field
                              class="font-weight-bold"
                              v-model="item.newG3"
                              label="Goal 3"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 1"
                              v-model="item.newG3S1"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 2"
                              v-model="item.newG3S2"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 3"
                              v-model="item.newG3S3"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 4"
                              v-model="item.newG3S4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" class="mt-2 mb-2 pa-6">
                          <v-card class="pa-6">
                            <v-text-field
                              class="font-weight-bold"
                              v-model="item.newG4"
                              label="Goal 4"
                              >Goal 4</v-text-field
                            >

                            <v-text-field
                              label="Support Item 1"
                              v-model="item.newG4S1"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 2"
                              v-model="item.newG4S2"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 3"
                              v-model="item.newG4S3"
                            ></v-text-field>

                            <v-text-field
                              label="Support Item 4"
                              v-model="item.newG4S4"
                            ></v-text-field>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 3"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 3" step="3" editable>
                    Section 3:
                    <small>Skills and Abilities</small>
                  </v-stepper-step>

                  <v-stepper-content step="3">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What are this indivdual's strengths, skills, and
                            abilities?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Strengths, Skills, and Abilities"
                            outlined
                            v-model="item.newStrengths"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 4"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 4" step="4" editable>
                    Section 4:
                    <small>Preferences and Routines</small>
                  </v-stepper-step>

                  <v-stepper-content step="4">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What are the individual's preferences and
                            non-negotiable routines (e.g., prefers to ride in
                            the front seat when riding in a car, has to touch
                            the house doorknob three times before leaving the
                            house, must brush his or her teeth before getting in
                            the shower, must call mom before going to bed,
                            etc.)?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            label="Preferences and Routines"
                            v-model="item.newPreferences"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 5"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 5" step="5" editable>
                    Section 5:
                    <small>Social and Recreational Activities</small>
                  </v-stepper-step>

                  <v-stepper-content step="5">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What interests does this individuals share with
                            other people their age? How can you, as the staff,
                            help this client develop friendships with other
                            members in the community?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            label="Shared Interests"
                            v-model="item.newInterests"
                          >
                          </v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What are some ways you can help with individual
                            participate in recreational or leisure activites of
                            their choice (e.g., brainstorm a list of preferred
                            activities in the community, invite the individual's
                            friends and peers to activities, etc.)?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            label="Help for recreation activities"
                            v-model="item.newRecreation"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 6"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 6" step="6" editable>
                    Section 6:
                    <small>Financial</small>
                  </v-stepper-step>

                  <v-stepper-content step="6">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Does {{ userCompany.Name }} manage this individuals
                            finances? If so, what is the individual's level of
                            involvement in his or her own finances (e.g., extent
                            of personal access to spending cash, debit or food
                            stamp card, etc.)?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Financial Involvement"
                            outlined
                            v-model="item.newFinancial"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 7"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 7" step="7" editable>
                    Section 7:
                    <small>Medical/Mental Health</small>
                  </v-stepper-step>

                  <v-stepper-content step="7">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What significant health concerns or issues exist for
                            this individual, if any?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Health Concerns"
                            outlined
                            v-model="item.newHealthConcerns"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What specific precautions must be taken to
                            appropriately address any health concerns or issues
                            listed above to maintain the health and safety of
                            this individual and staff (e.g., seizure protocol,
                            prevention of communicable disease protocol)?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Health Concerns Precautions"
                            outlined
                            v-model="item.newPrecautions"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What dietary issues or allergies to food or
                            medication does this individual have, if any?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Dietary Issues"
                            outlined
                            v-model="item.newDiet"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            How can you tell when this individual is becoming
                            ill?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Client becoming ill"
                            outlined
                            v-model="item.newIll"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What swallowing or eating difficulties does this
                            individual have, if any?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Eating difficulties"
                            outlined
                            v-model="item.newEating"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What mental health services does this individual
                            participate in, if any? If so, what goals or issues
                            is this individual working on?
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Goals or issues"
                            outlined
                            v-model="item.newGoals"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <h2 class="text-center font-weight-bold">
                            Medications
                          </h2>
                        </v-col>
                        <v-col cols="12" sm="3" v-for="medication in item.medications" :key="medication._id">
                          <v-card class="pa-4" >
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="medication.Medication"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="medication.purpose"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="medication.sideEffects"
                            ></v-text-field>
                          </v-card>
                        </v-col>


                      <!-- deprecated medication form -->
                      <!--
                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed1"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp1"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide1"
                            ></v-text-field>
                          </v-card>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed2"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp2"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide2"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed3"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp3"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide3"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed4"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp4"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed5"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp5"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide5"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed6"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp6"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide6"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed7"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp7"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide7"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed8"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp8"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide8"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed9"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp9"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide9"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed10"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp10"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide10"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed11"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp11"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide11"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed12"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp12"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide12"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed13"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp13"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide13"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed14"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp14"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide14"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed15"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp15"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide15"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed16"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp16"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide16"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed17"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp17"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide17"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed18"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp18"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide18"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed19"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp19"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide19"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="3">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Medication Name"
                              filled
                              v-model="item.newMed20"
                            ></v-text-field>
                            <v-text-field
                              label="Purpose"
                              filled
                              v-model="item.newPurp20"
                            ></v-text-field>
                            <v-text-field
                              label="Possible Side Effects"
                              filled
                              v-model="item.newSide20"
                            ></v-text-field>
                          </v-card>
                        </v-col> -->

                      <!-- deprecated medication form -->


                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 8"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 8" step="8" editable>
                    Section 8:
                    <small>Rights Restrictions</small>
                  </v-stepper-step>

                  <v-stepper-content step="8">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Does this individual have any Rights Restrictions?
                          </div>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div>I read the client's Right Restrictions</div>
                          <v-checkbox
                            label="Signature"
                            v-model="item.newReadRR"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Please list all right restrictions that are
                            currently in place for this individual.
                          </div>
                          <v-textarea
                            outlined
                            label="Rights Restrictions"
                            v-model="item.newRights"
                          ></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What are the staff supervision requirements for this
                            individual (e.g., 24 hour supervision, has set
                            amount of unsupervised time per day, etc.)
                          </div>
                          <v-textarea
                            outlined
                            label="Staff Supervision Requirements"
                            v-model="item.newSupervision"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 9"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 9" step="9" editable>
                    Section 9:
                    <small>Behavioral Intervention</small>
                  </v-stepper-step>

                  <v-stepper-content step="9">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Does this individual receive behavior consultation
                            supports?
                          </div>
                          <v-checkbox
                            label="Yes"
                            v-model="item.newBCS"
                          ></v-checkbox>
                          <div>I Read the Client's Behavior Support Plan</div>
                          <v-checkbox
                            label="Signature"
                            v-model="item.newReadBCS"
                          ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Please list and define the individual's target
                            behavior(s) as outlined in his or her Behavior
                            Support Plan.
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar1"
                            ></v-text-field>
                            <v-text-field
                              label="Definition"
                              filled
                              v-model="item.newDef1"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar2"
                            ></v-text-field>
                            <v-text-field
                              label="Definition"
                              filled
                              v-model="item.newDef2"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar3"
                            ></v-text-field>
                            <v-text-field
                              label="Definition"
                              filled
                              v-model="item.newDef3"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar4"
                            ></v-text-field>
                            <v-text-field
                              filled
                              label="Definition"
                              v-model="item.newDef4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              filled
                              label="Target Behavior"
                              v-model="item.newTar5"
                            ></v-text-field>
                            <v-text-field
                              filled
                              label="Definition"
                              v-model="item.newDef5"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              filled
                              label="Target Behavior"
                              v-model="item.newTar6"
                            ></v-text-field>
                            <v-text-field
                              label="Definition"
                              filled
                              v-model="item.newDef6"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Please indicate the triggering event(s) for each
                            target behavior as outlined in the inidividual's
                            Behavior Support Plan.
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar1"
                            ></v-text-field>
                            <v-text-field
                              label="Trigger Event"
                              filled
                              v-model="item.newTrig1"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar2"
                            ></v-text-field>
                            <v-text-field
                              label="Trigger Event"
                              filled
                              v-model="item.newTrig2"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar3"
                            ></v-text-field>
                            <v-text-field
                              label="Trigger Event"
                              filled
                              v-model="item.newTrig3"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar4"
                            ></v-text-field>
                            <v-text-field
                              filled
                              label="Trigger Event"
                              v-model="item.newTrig4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              filled
                              label="Target Behavior"
                              v-model="item.newTar5"
                            ></v-text-field>
                            <v-text-field
                              filled
                              label="Trigger Event"
                              v-model="item.newTrig5"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              filled
                              label="Target Behavior"
                              v-model="item.newTar6"
                            ></v-text-field>
                            <v-text-field
                              label="Trigger Event"
                              filled
                              v-model="item.newTrig6"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Please list at least THREE different intervention
                            and prevention measures for each target behavior as
                            outlined in the individual's Behavior Support Plan.
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar1"
                            ></v-text-field>
                            <v-text-field
                              label="Intervention/Prevention Measures"
                              filled
                              v-model="item.newInt1"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar2"
                            ></v-text-field>
                            <v-text-field
                              label="Intervention/Prevention Measures"
                              filled
                              v-model="item.newInt2"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar3"
                            ></v-text-field>
                            <v-text-field
                              label="Intervention/Prevention Measures"
                              filled
                              v-model="item.newInt3"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Target Behavior"
                              filled
                              v-model="item.newTar4"
                            ></v-text-field>
                            <v-text-field
                              filled
                              label="Intervention/Prevention Measures"
                              v-model="item.newInt4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              filled
                              label="Target Behavior"
                              v-model="item.newTar5"
                            ></v-text-field>
                            <v-text-field
                              filled
                              label="Intervention/Prevention Measures"
                              v-model="item.newInt5"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              filled
                              label="Target Behavior"
                              v-model="item.newTar6"
                            ></v-text-field>
                            <v-text-field
                              label="Intervention/Prevention Measures"
                              filled
                              v-model="item.newInt6"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Please list ONE behavior and ONE reponse for each
                            behavioral "phase" outlined in the client's Behavior
                            Support Plan.
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Phase"
                              value="Baseline"
                              filled
                              v-model="item.newPhase1"
                            ></v-text-field>
                            <v-text-field
                              label="Behavior"
                              filled
                              v-model="item.newBehavior1"
                            ></v-text-field>
                            <v-text-field
                              label="Staff Response"
                              filled
                              v-model="item.newResp1"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Phase"
                              value="Stimulation"
                              filled
                              v-model="item.newPhase2"
                            ></v-text-field>
                            <v-text-field
                              label="Behavior"
                              filled
                              v-model="item.newBehavior2"
                            ></v-text-field>
                            <v-text-field
                              label="Staff Response"
                              filled
                              v-model="item.newResp2"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Phase"
                              value="Escalation"
                              filled
                              v-model="item.newPhase3"
                            ></v-text-field>
                            <v-text-field
                              label="Behavior"
                              filled
                              v-model="item.newBehavior3"
                            ></v-text-field>
                            <v-text-field
                              label="Staff Response"
                              filled
                              v-model="item.newResp3"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Phase"
                              value="Crisis"
                              filled
                              v-model="item.newPhase4"
                            ></v-text-field>
                            <v-text-field
                              label="Behavior"
                              filled
                              v-model="item.newBehavior4"
                            ></v-text-field>
                            <v-text-field
                              label="Staff Response"
                              filled
                              v-model="item.newResp4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Phase"
                              value="De-escalation"
                              filled
                              v-model="item.newPhase5"
                            ></v-text-field>
                            <v-text-field
                              label="Behavior"
                              filled
                              v-model="item.newBehavior5"
                            ></v-text-field>
                            <v-text-field
                              label="Staff Response"
                              filled
                              v-model="item.newResp5"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Phase"
                              value="Stabilization"
                              filled
                              v-model="item.newPhase6"
                            ></v-text-field>
                            <v-text-field
                              label="Behavior"
                              filled
                              v-model="item.newBehavior6"
                            ></v-text-field>
                            <v-text-field
                              label="Staff Response"
                              filled
                              v-model="item.newResp6"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Please list at least FIVE activities, items, etc.
                            that serve as a reinforcers for this individual.
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            outlined
                            label="Reinforcers"
                            v-model="item.newReinforce"
                          ></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            What specific things can you do to establish,
                            cultivate, and/or enhance your relationship with
                            this individual?
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            outlined
                            label="Enhancing Client Relationships"
                            v-model="item.newRelationship"
                          ></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <div class="font-weight-bold">
                            Under what circumstances should you implement
                            physical redirection or restraints with this
                            individual?
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            outlined
                            label="Redirection or Restraints"
                            v-model="item.newRedirection"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 10"> Continue </v-btn>
                  </v-stepper-content>

                  <v-stepper-step :complete="e6 > 10" step="10" editable>
                    Section 10:
                    <small>Support Team Members</small>
                  </v-stepper-step>

                  <v-stepper-content step="10">
                    <v-card class="mb-12" height="auto">
                      <v-row>
                        <v-col cols="12">
                          <div class="font-weight-bold">
                            I read the client's client profile
                            <v-checkbox
                              label="Yes"
                              v-model="item.newReadCCP"
                            ></v-checkbox>
                          </div>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Parent(s)"
                              filled
                              v-model="item.newRole1"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName1"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Guardian"
                              filled
                              v-model="item.newRole2"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName2"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Support Coordinator"
                              filled
                              v-model="item.newRole3"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName3"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Natural Supports"
                              filled
                              v-model="item.newRole4"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName4"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Behavior Specialist"
                              filled
                              v-model="item.newRole5"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName5"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Program Manager (Residential Services)"
                              filled
                              v-model="item.newRole6"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName6"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Program Coordinator (Residential Services)"
                              filled
                              v-model="item.newRole7"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName7"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Program Manager (Day Services)"
                              filled
                              v-model="item.newRole8"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName8"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Program Coordinator (Day Services)"
                              filled
                              v-model="item.newRole9"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName9"
                            ></v-text-field>
                          </v-card>
                        </v-col>

                        <v-col cols="12" sm="4">
                          <v-card class="pa-4">
                            <v-text-field
                              label="Role"
                              value="Program Manager/Job Coach (Employement)"
                              filled
                              v-model="item.newRole10"
                            ></v-text-field>
                            <v-text-field
                              label="Name"
                              filled
                              v-model="item.newName10"
                            ></v-text-field>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-btn color="primary" @click="e6 = 1"> Continue </v-btn>
                  </v-stepper-content>
                </v-stepper>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#259647"
              class="white--text"
              @click="addTest()"
              v-if="$route.params.action === 'add' && !isAuditorRole"
            >
              Save
            </v-btn>
            <v-btn
              fab
              small
              @click="printItem()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="$route.params.action === 'edit'"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              color="#2b6993"
              class="white--text"
              @click="updateTest()"
              v-if="$route.params.action === 'edit' && !isAuditorRole"
            >
              Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint" />

    <div id="printItem">
      <report-header>{{ staffName }} Client Test</report-header>
      <v-container>
        <v-row>
          <table>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Disability and Functional Impairment</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <th>Date</th>
              <td>
                {{ newDate }}
              </td>
            </tr>
            <tr>
              <th>Client Name</th>
              <td>
                {{ newClientName }}
              </td>
            </tr>
            <tr>
              <th>Program</th>
              <td>
                {{ newProgram }}
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="mb-2 font-weight-bold">
                  What physical and/or mental condition(s) (e.g., Autism
                  Spectrum Disorder Intellectual Disability, Cerebral Palsy,
                  Bipolar Disorder, Fetal Alcohol Syndrome, etc.) has this
                  individual been diagnosed with?
                </div>
                <span>Physical and Mental Condidtions</span>
                <div class="outlined">{{ newConditions }}</div>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="mb-2 font-weight-bold">
                  What areas of functioning (i.e., receptive and expressive
                  language, social and interpersonal; self-care; academic and
                  occupational; cognitive; health and wellness; etc.) area
                  affected by this individuals's physical and/or mental
                  condition and in what ways (e.g., "Kyle is non-verbal and is
                  therfore unable to express his needs verbally")?
                </div>
                <span>Affected Functions</span>
                <div class="outlined">{{ newFunctions }}</div>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Person-Centered Support Plan (PCSP)</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <th>I Read the Client's Person-Centered Support Plan</th>
              <td>
                {{ newReadPCSP ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <th>I Read the Client's Support Strategies</th>
              <td>
                {{ newReadCSS ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <th colspan="2" class="font-weight-bold text-center">
                <div class="pt-6 mb-4">
                  Please list each of the individual's goals and the support
                  item(s) for each goal.
                </div>
              </th>
            </tr>
            <tr>
              <th>Goal 1</th>
              <td>
                {{ newG1 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 1</th>
              <td>
                {{ newG1S1 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 2</th>
              <td>
                {{ newG1S2 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 3</th>
              <td>
                {{ newG1S3 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 4</th>
              <td>
                {{ newG1S4 }}
              </td>
            </tr>
            <tr>
              <th class="pt-6">Goal 2</th>
              <td class="pt-6">
                {{ newG2 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 1</th>
              <td>
                {{ newG2S1 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 2</th>
              <td>
                {{ newG2S2 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 3</th>
              <td>
                {{ newG2S3 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 4</th>
              <td>
                {{ newG2S4 }}
              </td>
            </tr>
            <tr>
              <th class="pt-6">Goal 3</th>
              <td class="pt-6">
                {{ newG3 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 1</th>
              <td>
                {{ newG3S1 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 2</th>
              <td>
                {{ newG3S2 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 3</th>
              <td>
                {{ newG3S3 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 4</th>
              <td>
                {{ newG3S4 }}
              </td>
            </tr>
            <tr>
              <th class="pt-6">Goal 4</th>
              <td class="pt-6">
                {{ newG4 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 1</th>
              <td>
                {{ newG4S1 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 2</th>
              <td>
                {{ newG4S2 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 3</th>
              <td>
                {{ newG4S3 }}
              </td>
            </tr>
            <tr>
              <th>Support Item 4</th>
              <td>
                {{ newG4S4 }}
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Skills and Abilities</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What are this indivdual's strengths, skills, and abilities?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>"Strengths, Skills, and Abilities</span>

                  <div class="outlined">{{ newStrengths }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Preferences and Routines</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What are the individual's preferences and non-negotiable
                    routines (e.g., prefers to ride in the front seat when
                    riding in a car, has to touch the house doorknob three times
                    before leaving the house, must brush his or her teeth before
                    getting in the shower, must call mom before going to bed,
                    etc.)?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Preferences and Routines</span>

                  <div class="outlined">{{ newPreferences }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Social and Recreational Activities</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What interests does this individuals share with other people
                    their age? How can you, as the staff, help this client
                    develop friendships with other members in the community?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Shared Interests</span>
                  <div class="outlined">{{ newInterests }}</div>
                </v-col>
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What are some ways you can help with individual participate
                    in recreational or leisure activites of their choice (e.g.,
                    brainstorm a list of preferred activities in the community,
                    invite the individual's friends and peers to activities,
                    etc.)?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Help for recreation activities</span>
                  <div class="outlined">{{ newRecreation }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Financial</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    Does Redhead Supports manage this individuals finances? If
                    so, what is the individual's level of involvement in his or
                    her own finances (e.g., extent of personal access to
                    spending cash, debit or food stamp card, etc.)?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Financial Involvement</span>
                  <div class="outlined">{{ newFinancial }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Medical/Mental Health</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What significant health concerns or issues exist for this
                    individual, if any?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Health Concerns</span>

                  <div class="outlined">{{ newHealthConcerns }}</div>
                </v-col>
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What specific precautions must be taken to appropriately
                    address any health concerns or issues listed above to
                    maintain the health and safety of this individual and staff
                    (e.g., seizure protocol, prevention of communicable disease
                    protocol)?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Health Concerns Precautions</span>

                  <div class="outlined">{{ newPrecautions }}</div>
                </v-col>
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What dietary issues or allergies to food or medication does
                    this individual have, if any?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Dietary Issues</span>

                  <div class="outlined">{{ newDiet }}</div>
                </v-col>
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    How can you tell when this individual is becoming ill?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Client becoming ill</span>

                  <div class="outlined">{{ newIll }}</div>
                </v-col>
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What swallowing or eating difficulties does this individual
                    have, if any?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Eating difficulties</span>

                  <div class="outlined">{{ newEating }}</div>
                </v-col>
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What mental health services does this individual participate
                    in, if any? If so, what goals or issues is this individual
                    working on?
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <span>Goals or issues</span>

                  <div class="outlined">{{ newGoals }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Medications</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <th>Medication Name</th>
              <td>
                {{ newMed1 }}
              </td>
            </tr>
            <tr>
              <th>Purpose</th>
              <td>
                {{ newPurp1 }}
              </td>
            </tr>
            <tr>
              <th>Possible Side Effects</th>
              <td>
                {{ newSide1 }}
              </td>
            </tr>
            <tr v-if="newMed2">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed2 }}
              </td>
            </tr>
            <tr v-if="newMed2">
              <th>Purpose</th>
              <td>
                {{ newPurp2 }}
              </td>
            </tr>
            <tr v-if="newMed2">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide2 }}
              </td>
            </tr>
            <tr v-if="newMed3">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed3 }}
              </td>
            </tr>
            <tr v-if="newMed3">
              <th>Purpose</th>
              <td>
                {{ newPurp3 }}
              </td>
            </tr>
            <tr v-if="newMed3">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide3 }}
              </td>
            </tr>
            <tr v-if="newMed4">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed4 }}
              </td>
            </tr>
            <tr v-if="newMed4">
              <th>Purpose</th>
              <td>
                {{ newPurp4 }}
              </td>
            </tr>
            <tr v-if="newMed4">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide4 }}
              </td>
            </tr>
            <tr v-if="newMed5">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed5 }}
              </td>
            </tr>
            <tr v-if="newMed5">
              <th>Purpose</th>
              <td>
                {{ newPurp5 }}
              </td>
            </tr>
            <tr v-if="newMed5">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide5 }}
              </td>
            </tr>
            <tr v-if="newMed6">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed6 }}
              </td>
            </tr>
            <tr v-if="newMed6">
              <th>Purpose</th>
              <td>
                {{ newPurp6 }}
              </td>
            </tr>
            <tr v-if="newMed6">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide6 }}
              </td>
            </tr>
            <tr v-if="newMed7">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed7 }}
              </td>
            </tr>
            <tr v-if="newMed7">
              <th>Purpose</th>
              <td>
                {{ newPurp7 }}
              </td>
            </tr>
            <tr v-if="newMed7">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide7 }}
              </td>
            </tr>
            <tr v-if="newMed8">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed8 }}
              </td>
            </tr>
            <tr v-if="newMed8">
              <th>Purpose</th>
              <td>
                {{ newPurp8 }}
              </td>
            </tr>
            <tr v-if="newMed8">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide8 }}
              </td>
            </tr>
            <tr v-if="newMed9">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed9 }}
              </td>
            </tr>
            <tr v-if="newMed9">
              <th>Purpose</th>
              <td>
                {{ newPurp9 }}
              </td>
            </tr>
            <tr v-if="newMed9">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide9 }}
              </td>
            </tr>
            <tr v-if="newMed10">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed10 }}
              </td>
            </tr>
            <tr v-if="newMed10">
              <th>Purpose</th>
              <td>
                {{ newPurp10 }}
              </td>
            </tr>
            <tr v-if="newMed10">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide10 }}
              </td>
            </tr>
            <tr v-if="newMed11">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed11 }}
              </td>
            </tr>
            <tr v-if="newMed11">
              <th>Purpose</th>
              <td>
                {{ newPurp11 }}
              </td>
            </tr>
            <tr v-if="newMed11">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide11 }}
              </td>
            </tr>
            <tr v-if="newMed12">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed12 }}
              </td>
            </tr>
            <tr v-if="newMed12">
              <th>Purpose</th>
              <td>
                {{ newPurp12 }}
              </td>
            </tr>
            <tr v-if="newMed12">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide12 }}
              </td>
            </tr>
            <tr v-if="newMed13">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed13 }}
              </td>
            </tr>
            <tr v-if="newMed13">
              <th>Purpose</th>
              <td>
                {{ newPurp13 }}
              </td>
            </tr>
            <tr v-if="newMed13">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide13 }}
              </td>
            </tr>
            <tr v-if="newMed14">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed14 }}
              </td>
            </tr>
            <tr v-if="newMed14">
              <th>Purpose</th>
              <td>
                {{ newPurp14 }}
              </td>
            </tr>
            <tr v-if="newMed14">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide14 }}
              </td>
            </tr>
            <tr v-if="newMed15">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed15 }}
              </td>
            </tr>
            <tr v-if="newMed15">
              <th>Purpose</th>
              <td>
                {{ newPurp15 }}
              </td>
            </tr>
            <tr v-if="newMed15">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide15 }}
              </td>
            </tr>
            <tr v-if="newMed16">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed16 }}
              </td>
            </tr>
            <tr v-if="newMed16">
              <th>Purpose</th>
              <td>
                {{ newPurp16 }}
              </td>
            </tr>
            <tr v-if="newMed16">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide16 }}
              </td>
            </tr>
            <tr v-if="newMed17">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed17 }}
              </td>
            </tr>
            <tr v-if="newMed17">
              <th>Purpose</th>
              <td>
                {{ newPurp17 }}
              </td>
            </tr>
            <tr v-if="newMed17">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide17 }}
              </td>
            </tr>
            <tr v-if="newMed18">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed18 }}
              </td>
            </tr>
            <tr v-if="newMed18">
              <th>Purpose</th>
              <td>
                {{ newPurp18 }}
              </td>
            </tr>
            <tr v-if="newMed18">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide18 }}
              </td>
            </tr>
            <tr v-if="newMed19">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed19 }}
              </td>
            </tr>
            <tr v-if="newMed19">
              <th>Purpose</th>
              <td>
                {{ newPurp19 }}
              </td>
            </tr>
            <tr v-if="newMed19">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide19 }}
              </td>
            </tr>
            <tr v-if="newMed20">
              <th class="pt-6">Medication Name</th>
              <td class="pt-6">
                {{ newMed20 }}
              </td>
            </tr>
            <tr v-if="newMed20">
              <th>Purpose</th>
              <td>
                {{ newPurp20 }}
              </td>
            </tr>
            <tr v-if="newMed20">
              <th>Possible Side Effects</th>
              <td>
                {{ newSide20 }}
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Rights Restrictions</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <div class="font-weight-bold">
                  Does this individual have any Rights Restrictions?
                </div>
              </td>
            </tr>
            <tr>
              <th>I read the client's Right Restrictions</th>
              <td>
                {{ newReadRR ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    Please list all right restrictions that are currently in
                    place for this individual.
                  </div>
                  <span>Rights Restrictions</span>

                  <div class="outlined">{{ newRights }}</div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What are the staff supervision requirements for this
                    individual (e.g., 24 hour supervision, has set amount of
                    unsupervised time per day, etc.)
                  </div>
                  <span>Staff Supervision Requirements</span>
                  <div class="outlined">{{ newSupervision }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    Please list all right restrictions that are currently in
                    place for this individual.
                  </div>
                  <span>Rights Restrictions</span>

                  <div class="outlined">{{ newRights }}</div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What are the staff supervision requirements for this
                    individual (e.g., 24 hour supervision, has set amount of
                    unsupervised time per day, etc.)
                  </div>
                  <span>Staff Supervision Requirements</span>
                  <div class="outlined">{{ newSupervision }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Behavioral Intervention</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <th>
                Does this individual receive behavior consultation supports?
              </th>
              <td>
                {{ newBCS ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <th>I Read the Client's Behavior Support Plan</th>
              <td>
                {{ newReadBCS ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="font-weight-bold pt-8">
                  Please list and define the individual's target behavior(s) as
                  outlined in his or her Behavior Support Plan.
                </div>
              </td>
            </tr>
            <tr>
              <th>Target Behavior 1</th>
              <td>
                {{ newTar1 }}
              </td>
            </tr>
            <tr>
              <th>Definition</th>
              <td>
                {{ newDef1 }}
              </td>
            </tr>
            <tr v-if="newTar2">
              <th class="pt-6">Target Behavior 2</th>
              <td class="pt-6">
                {{ newTar2 }}
              </td>
            </tr>
            <tr v-if="newTar2">
              <th>Definition</th>
              <td>
                {{ newDef2 }}
              </td>
            </tr>
            <tr v-if="newTar3">
              <th class="pt-6">Target Behavior 3</th>
              <td class="pt-6">
                {{ newTar3 }}
              </td>
            </tr>
            <tr v-if="newTar3">
              <th>Definition</th>
              <td>
                {{ newDef3 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th class="pt-6">Target Behavior 4</th>
              <td class="pt-6">
                {{ newTar4 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th>Definition</th>
              <td>
                {{ newDef4 }}
              </td>
            </tr>
            <tr v-if="newTar5">
              <th class="pt-6">Target Behavior 5</th>
              <td class="pt-6">
                {{ newTar5 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th>Definition</th>
              <td>
                {{ newDef5 }}
              </td>
            </tr>
            <tr v-if="newTar6">
              <th class="pt-6">Target Behavior 6</th>
              <td class="pt-6">
                {{ newTar6 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th>Definition</th>
              <td>
                {{ newDef6 }}
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <div class="font-weight-bold pt-8">
                  Please indicate the triggering event(s) for each target
                  behavior as outlined in the inidividual's Behavior Support
                  Plan.
                </div>
              </th>
            </tr>
            <tr>
              <th>Target Behavior 1</th>
              <td>
                {{ newTar1 }}
              </td>
            </tr>
            <tr>
              <th>Trigger Event</th>
              <td>
                {{ newTrig1 }}
              </td>
            </tr>
            <tr v-if="newTar2">
              <th class="pt-6">Target Behavior 2</th>
              <td class="pt-6">
                {{ newTar2 }}
              </td>
            </tr>
            <tr v-if="newTar2">
              <th>Trigger Event</th>
              <td>
                {{ newTrig2 }}
              </td>
            </tr>
            <tr v-if="newTar3">
              <th class="pt-6">Target Behavior 3</th>
              <td class="pt-6">
                {{ newTar3 }}
              </td>
            </tr>
            <tr v-if="newTar3">
              <th>Trigger Event</th>
              <td>
                {{ newTrig3 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th class="pt-6">Target Behavior 4</th>
              <td class="pt-6">
                {{ newTar4 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th>Trigger Event</th>
              <td>
                {{ newTrig4 }}
              </td>
            </tr>
            <tr v-if="newTar5">
              <th class="pt-6">Target Behavior 5</th>
              <td class="pt-6">
                {{ newTar5 }}
              </td>
            </tr>
            <tr v-if="newTar5">
              <th>Trigger Event</th>
              <td>
                {{ newTrig5 }}
              </td>
            </tr>
            <tr v-if="newTar6">
              <th class="pt-6">Target Behavior 6</th>
              <td class="pt-6">
                {{ newTar6 }}
              </td>
            </tr>
            <tr v-if="newTar6">
              <th>Trigger Event</th>
              <td>
                {{ newTrig6 }}
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <div class="font-weight-bold pt-8">
                  Please list at least THREE different intervention and
                  prevention measures for each target behavior as outlined in
                  the individual's Behavior Support Plan.
                </div>
              </th>
            </tr>
            <tr>
              <th>Target Behavior 1</th>
              <td>
                {{ newTar1 }}
              </td>
            </tr>
            <tr>
              <th>Intervention/Prevention Measures</th>
              <td>
                {{ newInt1 }}
              </td>
            </tr>
            <tr v-if="newTar2">
              <th class="pt-6">Target Behavior 2</th>
              <td class="pt-6">
                {{ newTar2 }}
              </td>
            </tr>
            <tr v-if="newTar2">
              <th>Intervention/Prevention Measures</th>
              <td>
                {{ newInt2 }}
              </td>
            </tr>
            <tr v-if="newTar3">
              <th class="pt-6">Target Behavior 3</th>
              <td class="pt-6">
                {{ newTar3 }}
              </td>
            </tr>
            <tr v-if="newTar3">
              <th>Intervention/Prevention Measures</th>
              <td>
                {{ newInt3 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th class="pt-6">Target Behavior 4</th>
              <td class="pt-6">
                {{ newTar4 }}
              </td>
            </tr>
            <tr v-if="newTar4">
              <th>Intervention/Prevention Measures</th>
              <td>
                {{ newInt4 }}
              </td>
            </tr>
            <tr v-if="newTar5">
              <th class="pt-6">Target Behavior 5</th>
              <td class="pt-6">
                {{ newTar5 }}
              </td>
            </tr>
            <tr v-if="newTar5">
              <th>Intervention/Prevention Measures</th>
              <td>
                {{ newInt5 }}
              </td>
            </tr>
            <tr v-if="newTar6">
              <th class="pt-6">Target Behavior 6</th>
              <td class="pt-6">
                {{ newTar6 }}
              </td>
            </tr>
            <tr v-if="newTar6">
              <th>Intervention/Prevention Measures</th>
              <td>
                {{ newInt6 }}
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <div class="font-weight-bold pt-8">
                  Please list ONE behavior and ONE reponse for each behavioral
                  "phase" outlined in the client's Behavior Support Plan.
                </div>
              </th>
            </tr>
            <tr>
              <th>Phase 1</th>
              <td>
                {{ newPhase1 }}
              </td>
            </tr>
            <tr>
              <th>Behavior</th>
              <td>
                {{ newBehavior1 }}
              </td>
            </tr>
            <tr>
              <th>Staff Response</th>
              <td>
                {{ newResp1 }}
              </td>
            </tr>
            <tr v-if="newPhase2">
              <th class="pt-6">Phase 2</th>
              <td class="pt-6">
                {{ newPhase2 }}
              </td>
            </tr>
            <tr v-if="newPhase2">
              <th>Behavior</th>
              <td>
                {{ newBehavior2 }}
              </td>
            </tr>
            <tr v-if="newPhase2">
              <th>Staff Response</th>
              <td>
                {{ newResp2 }}
              </td>
            </tr>
            <tr v-if="newPhase3">
              <th class="pt-6">Phase 3</th>
              <td class="pt-6">
                {{ newPhase3 }}
              </td>
            </tr>
            <tr v-if="newPhase3">
              <th>Behavior</th>
              <td>
                {{ newBehavior3 }}
              </td>
            </tr>
            <tr v-if="newPhase3">
              <th>Staff Response</th>
              <td>
                {{ newResp3 }}
              </td>
            </tr>
            <tr v-if="newPhase4">
              <th class="pt-6">Phase 4</th>
              <td class="pt-6">
                {{ newPhase4 }}
              </td>
            </tr>
            <tr v-if="newPhase4">
              <th>Behavior</th>
              <td>
                {{ newBehavior4 }}
              </td>
            </tr>
            <tr v-if="newPhase4">
              <th>Staff Response</th>
              <td>
                {{ newResp4 }}
              </td>
            </tr>
            <tr v-if="newPhase5">
              <th class="pt-6">Phase 5</th>
              <td class="pt-6">
                {{ newPhase5 }}
              </td>
            </tr>
            <tr v-if="newPhase5">
              <th>Behavior</th>
              <td>
                {{ newBehavior5 }}
              </td>
            </tr>
            <tr v-if="newPhase5">
              <th>Staff Response</th>
              <td>
                {{ newResp5 }}
              </td>
            </tr>
            <tr v-if="newPhase6">
              <th class="pt-6">Phase 6</th>
              <td class="pt-6">
                {{ newPhase6 }}
              </td>
            </tr>
            <tr v-if="newPhase6">
              <th>Behavior</th>
              <td>
                {{ newBehavior6 }}
              </td>
            </tr>
            <tr v-if="newPhase6">
              <th>Staff Response</th>
              <td>
                {{ newResp6 }}
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <div class="font-weight-bold pt-8">
                  Please list at least FIVE activities, items, etc. that serve
                  as a reinforcers for this individual.
                </div>
              </th>
            </tr>
            <tr>
              <td colspan="2">
                <v-col cols="12">
                  <span>Reinforcers</span>
                  <div class="outlined">{{ newReinforce }}</div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    What specific things can you do to establish, cultivate,
                    and/or enhance your relationship with this individual?
                  </div>
                </v-col>
                <v-col cols="12">
                  <span>Enhancing Client Relationships</span>
                  <div class="outlined">{{ newRelationship }}</div>
                </v-col>

                <v-col cols="12" sm="12">
                  <div class="font-weight-bold">
                    Under what circumstances should you implement physical
                    redirection or restraints with this individual?
                  </div>
                </v-col>
                <v-col cols="12">
                  <span>Redirection or Restraints</span>
                  <div class="outlined">{{ newRedirection }}</div>
                </v-col>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <h3 class="pt-6">Support Team Members</h3>
                <hr />
              </th>
            </tr>
            <tr>
              <th>I read the client's client profile</th>
              <td>
                {{ newReadCCP ? "Yes" : "No" }}
              </td>
            </tr>
            <tr>
              <th>Role</th>
              <td>
                {{ newRole1 }}
              </td>
            </tr>
            <tr>
              <th>Name</th>
              <td>
                {{ newName1 }}
              </td>
            </tr>
            <tr v-if="newRole2">
              <th class="pt-6">Role 2</th>
              <td class="pt-6">
                {{ newRole2 }}
              </td>
            </tr>
            <tr v-if="newRole2">
              <th>Name</th>
              <td>
                {{ newName2 }}
              </td>
            </tr>
            <tr v-if="newRole3">
              <th class="pt-6">Role 3</th>
              <td class="pt-6">
                {{ newRole3 }}
              </td>
            </tr>
            <tr v-if="newRole3">
              <th>Name</th>
              <td>
                {{ newName3 }}
              </td>
            </tr>
            <tr v-if="newRole4">
              <th class="pt-6">Role 4</th>
              <td class="pt-6">
                {{ newRole4 }}
              </td>
            </tr>
            <tr v-if="newRole4">
              <th>Name</th>
              <td>
                {{ newName4 }}
              </td>
            </tr>
            <tr v-if="newRole5">
              <th class="pt-6">Role 5</th>
              <td class="pt-6">
                {{ newRole5 }}
              </td>
            </tr>
            <tr v-if="newRole5">
              <th>Name</th>
              <td>
                {{ newName5 }}
              </td>
            </tr>
            <tr v-if="newRole6">
              <th class="pt-6">Role 6</th>
              <td class="pt-6">
                {{ newRole6 }}
              </td>
            </tr>
            <tr v-if="newRole6">
              <th>Name</th>
              <td>
                {{ newName6 }}
              </td>
            </tr>
            <tr v-if="newRole7">
              <th class="pt-6">Role 7</th>
              <td class="pt-6">
                {{ newRole7 }}
              </td>
            </tr>
            <tr v-if="newRole7">
              <th>Name</th>
              <td>
                {{ newName7 }}
              </td>
            </tr>
            <tr v-if="newRole8">
              <th class="pt-6">Role 8</th>
              <td class="pt-6">
                {{ newRole8 }}
              </td>
            </tr>
            <tr v-if="newRole8">
              <th>Name</th>
              <td>
                {{ newName8 }}
              </td>
            </tr>
            <tr v-if="newRole9">
              <th class="pt-6">Role 9</th>
              <td class="pt-6">
                {{ newRole9 }}
              </td>
            </tr>
            <tr v-if="newRole9">
              <th>Name</th>
              <td>
                {{ newName9 }}
              </td>
            </tr>
            <tr v-if="newRole10">
              <th class="pt-6">Role 10</th>
              <td class="pt-6">
                {{ newRole10 }}
              </td>
            </tr>
            <tr v-if="newRole10">
              <th>Name</th>
              <td>
                {{ newName10 }}
              </td>
            </tr>
          </table>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
import axios from "axios";
import StaffNav from "@/components/StaffNav";
import Foot from "@/components/Footer";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import ReportHeader from "@/components/Report/ReportHeader.vue";
import AnnualDocsDialog from '@/components/AnnualDocs/AnnualDocsDialog.vue'
import DateTimeUtil from "../../../../utils/date-time.util";
const url = require("../../../client_config/config").url;

export default {
  components: {
    StaffNav,
    Foot,
    ReportHeader,
    AnnualDocsDialog
  },
  data: function () {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "Date",
        },
        { text: "Employee Name", value: "Employee.Name" },
        { text: "Client Name", value: "ClientName" },
        { text: "Program", value: "Program" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      printHeaders: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "Date",
        },
        { text: "Employee Name", value: "Employee.Name" },
        { text: "Client Name", value: "ClientName" },
        { text: "Program", value: "Program" },
      ],
      e6: 1,
      dialog: false,
      editTest: false,
      newTest: false,
      msg: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      search: "",
      text: "",
      tests: [],
      tempData: [],
      clients: [],
      units: [],
      employeeID: this.$route.params.employeeID,
      titleForm: "New Client Test",
      staffTestID: "",
      newDate: "",
      newClientName: "",
      newProgram: "",
      newConditions: "",
      newFunctions: "",
      newReadPCSP: "",
      newReadCSS: "",
      newG1: "",
      newG1S1: "",
      newG1S2: "",
      newG1S3: "",
      newG1S4: "",
      newG2: "",
      newG2S1: "",
      newG2S2: "",
      newG2S3: "",
      newG2S4: "",
      newG3: "",
      newG3S1: "",
      newG3S2: "",
      newG3S3: "",
      newG3S4: "",
      newG4: "",
      newG4S1: "",
      newG4S2: "",
      newG4S3: "",
      newG4S4: "",
      newStrengths: "",
      newPreferences: "",
      newInterests: "",
      newRecreation: "",
      newFinancial: "",
      newHealthConcerns: "",
      newPrecautions: "",
      newDiet: "",
      newIll: "",
      newEating: "",
      newGoals: "",
      newMed1: "",
      newPurp1: "",
      newSide1: "",
      newMed2: "",
      newPurp2: "",
      newSide2: "",
      newMed3: "",
      newPurp3: "",
      newSide3: "",
      newMed4: "",
      newPurp4: "",
      newSide4: "",
      newMed5: "",
      newPurp5: "",
      newSide5: "",
      newMed6: "",
      newPurp6: "",
      newSide6: "",
      newMed7: "",
      newPurp7: "",
      newSide7: "",
      newMed8: "",
      newPurp8: "",
      newSide8: "",
      newMed9: "",
      newPurp9: "",
      newSide9: "",
      newMed10: "",
      newPurp10: "",
      newSide10: "",
      newMed11: "",
      newPurp11: "",
      newSide11: "",
      newMed12: "",
      newPurp12: "",
      newSide12: "",
      newMed13: "",
      newPurp13: "",
      newSide13: "",
      newMed14: "",
      newPurp14: "",
      newSide14: "",
      newMed15: "",
      newPurp15: "",
      newSide15: "",
      newMed16: "",
      newPurp16: "",
      newSide16: "",
      newMed17: "",
      newPurp17: "",
      newSide17: "",
      newMed18: "",
      newPurp18: "",
      newSide18: "",
      newMed19: "",
      newPurp19: "",
      newSide19: "",
      newMed20: "",
      newPurp20: "",
      newSide20: "",
      newReadRR: "",
      newRights: "",
      newSupervision: "",
      newBCS: "",
      newReadBCS: "",
      newTar1: "",
      newDef1: "",
      newTar2: "",
      newDef2: "",
      newTar3: "",
      newDef3: "",
      newTar4: "",
      newDef4: "",
      newTar5: "",
      newDef5: "",
      newTar6: "",
      newDef6: "",
      newTrig1: "",
      newTrig2: "",
      newTrig3: "",
      newTrig4: "",
      newTrig5: "",
      newTrig6: "",
      newInt1: "",
      newInt2: "",
      newInt3: "",
      newInt4: "",
      newInt5: "",
      newInt6: "",
      newPhase1: "",
      newBehavior1: "",
      newResp1: "",
      newPhase2: "",
      newBehavior2: "",
      newResp2: "",
      newPhase3: "",
      newBehavior3: "",
      newResp3: "",
      newPhase4: "",
      newBehavior4: "",
      newResp4: "",
      newPhase5: "",
      newBehavior5: "",
      newResp5: "",
      newPhase6: "",
      newBehavior6: "",
      newResp6: "",
      newReinforce: "",
      newRelationship: "",
      newRedirection: "",
      newReadCCP: "",
      newRole1: "",
      newName1: "",
      newRole2: "",
      newName2: "",
      newRole3: "",
      newName3: "",
      newRole4: "",
      newName4: "",
      newRole5: "",
      newName5: "",
      newRole6: "",
      newName6: "",
      newRole7: "",
      newName7: "",
      newRole8: "",
      newName8: "",
      newRole9: "",
      newName9: "",
      newRole10: "",
      newName10: "",
      isLoading: true,
      staffName: "",
      item: {
        medications: []
      },
      debounceTimeout: null,
      draftKey: null,
      snackbar: false,
      snackbarMsg: "",
      userState: localStorage.getItem("userState"),
      userCompanyIds: localStorage.getItem("userCompanies")
        ? JSON.parse(localStorage.getItem("userCompanies"))
        : [],
      userCompany: {},
      clientId: null,
      annualDocs: [],
      annualDocsExpirationDate: '',
      medications: [],
      behaviors: [],
      rigths: [],
      showAnnualDocsDialog: false,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
    // staffName() {
    //   // `this` points to the component instance
    //   return localStorage.getItem("Name");
    // },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    item: {
      deep: true,
      handler() {
        if (!this.editTest) {
          // this.autoSave();
        }
      },
    },
  },

  created() {
    this.getClients();
    this.getUnits();
    this.item.newDate = moment().format("YYYY-MM-DD");
    this.getCompanyById();
    this.draftKey = uuidv4();
    if (this.$route.query?.id) {
      this.getClientTestItems();
    }
  },

  methods: {
    initialize() {
      this.tests = [];
    },
    viewTest(item) {
      console.log(item);
      this.titleForm = "Viewing Client Test";
      this.dialog = true;
      this.editTest = true;
      this.newTest = false;
      this.newDate = moment(item.Date).format("YYYY-MM-DD");
      this.item.newClientName = item.ClientName;
      this.item.newProgram = item.Program;
      this.item.newConditions = item.Conditions;
      this.item.newFunctions = item.Functions;
      this.item.newReadPCSP = item.ReadPCSP;
      this.item.newReadCSS = item.ReadCSS;
      this.item.newG1 = item.G1;
      this.item.newG1S1 = item.G1S1;
      this.item.newG1S2 = item.G1S2;
      this.item.newG1S3 = item.G1S3;
      this.item.newG1S4 = item.G1S4;
      this.item.newG2 = item.G2;
      this.item.newG2S1 = item.G2S1;
      this.item.newG2S2 = item.G2S2;
      this.item.newG2S3 = item.G2S3;
      this.item.newG2S4 = item.G2S4;
      this.item.newG3 = item.G3;
      this.item.newG3S1 = item.G3S1;
      this.item.newG3S2 = item.G3S2;
      this.item.newG3S3 = item.G3S3;
      this.item.newG3S4 = item.G3S4;
      this.item.newG4 = item.G4;
      this.item.newG4S1 = item.G4S1;
      this.item.newG4S2 = item.G4S2;
      this.item.newG4S3 = item.G4S3;
      this.item.newG4S4 = item.G4S4;
      this.item.newStrengths = item.Strengths;
      this.item.newPreferences = item.Preferences;
      this.item.newInterests = item.Interests;
      this.item.newRecreation = item.Recreation;
      this.item.newFinancial = item.Financial;
      this.item.newHealthConcerns = item.HealthConcerns;
      this.item.newPrecautions = item.Precautions;
      this.item.newDiet = item.Diet;
      this.item.newIll = item.Ill;
      this.item.newEating = item.Eating;
      this.item.newGoals = item.Goals;
      this.item.newMed1 = item.Med1;
      this.item.newPurp1 = item.Purp1;
      this.item.newSide1 = item.Side1;
      this.item.newMed2 = item.Med2;
      this.item.newPurp2 = item.Purp2;
      this.item.newSide2 = item.Side2;
      this.item.newMed3 = item.Med3;
      this.item.newPurp3 = item.Purp3;
      this.item.newSide3 = item.Side3;
      this.item.newMed4 = item.Med4;
      this.item.newPurp4 = item.Purp4;
      this.item.newSide4 = item.Side4;
      this.item.newMed5 = item.Med5;
      this.item.newPurp5 = item.Purp5;
      this.item.newSide5 = item.Side5;
      this.item.newMed6 = item.Med6;
      this.item.newPurp6 = item.Purp6;
      this.item.newSide6 = item.Side6;
      this.item.newMed7 = item.Med7;
      this.item.newPurp7 = item.Purp7;
      this.item.newSide7 = item.Side7;
      this.item.newMed8 = item.Med8;
      this.item.newPurp8 = item.Purp8;
      this.item.newSide8 = item.Side8;
      this.item.newMed9 = item.Med9;
      this.item.newPurp9 = item.Purp9;
      this.item.newSide9 = item.Side9;
      this.item.newMed10 = item.Med10;
      this.item.newPurp10 = item.Purp10;
      this.item.newSide10 = item.Side10;
      this.item.newMed11 = item.Med11;
      this.item.newPurp11 = item.Purp11;
      this.item.newSide11 = item.Side11;
      this.item.newMed12 = item.Med12;
      this.item.newPurp12 = item.Purp12;
      this.item.newSide12 = item.Side12;
      this.item.newMed13 = item.Med13;
      this.item.newPurp13 = item.Purp13;
      this.item.newSide13 = item.Side13;
      this.item.newMed14 = item.Med14;
      this.item.newPurp14 = item.Purp14;
      this.item.newSide14 = item.Side14;
      this.item.newMed15 = item.Med15;
      this.item.newPurp15 = item.Purp15;
      this.item.newSide15 = item.Side15;
      this.item.newMed16 = item.Med16;
      this.item.newPurp16 = item.Purp16;
      this.item.newSide16 = item.Side16;
      this.item.newMed17 = item.Med17;
      this.item.newPurp17 = item.Purp17;
      this.item.newSide17 = item.Side17;
      this.item.newMed18 = item.Med18;
      this.item.newPurp18 = item.Purp18;
      this.item.newSide18 = item.Side18;
      this.item.newMed19 = item.Med19;
      this.item.newPurp19 = item.Purp19;
      this.item.newSide19 = item.Side19;
      this.item.newMed20 = item.Med20;
      this.item.newPurp20 = item.Purp20;
      this.item.newSide20 = item.Side20;
      this.item.newReadRR = item.ReadRR;
      this.item.newRights = item.Rights;
      this.item.newSupervision = item.Supervision;
      this.item.newBCS = item.BCS;
      this.item.newReadBCS = item.ReadBCS;
      this.item.newTar1 = item.Tar1;
      this.item.newDef1 = item.Def1;
      this.item.newTar2 = item.Tar2;
      this.item.newDef2 = item.Def2;
      this.item.newTar3 = item.Tar3;
      this.item.newDef3 = item.Def3;
      this.item.newTar4 = item.Tar4;
      this.item.newDef4 = item.Def4;
      this.item.newTar5 = item.Tar5;
      this.item.newDef5 = item.Def5;
      this.item.newTar6 = item.Tar6;
      this.item.newDef6 = item.Def6;
      this.item.newTrig1 = item.Trig1;
      this.item.newTrig2 = item.Trig2;
      this.item.newTrig3 = item.Trig3;
      this.item.newTrig4 = item.Trig4;
      this.item.newTrig5 = item.Trig5;
      this.item.newTrig6 = item.Trig6;
      this.item.newInt1 = item.Int1;
      this.item.newInt2 = item.Int2;
      this.item.newInt3 = item.Int3;
      this.item.newInt4 = item.Int4;
      this.item.newInt5 = item.Int5;
      this.item.newInt6 = item.Int6;
      this.item.newPhase1 = item.Phase1;
      this.item.newBehavior1 = item.Behavior1;
      this.item.newResp1 = item.Resp1;
      this.item.newPhase2 = item.Phase2;
      this.item.newBehavior2 = item.Behavior2;
      this.item.newResp2 = item.Resp2;
      this.item.newPhase3 = item.Phase3;
      this.item.newBehavior3 = item.Behavior3;
      this.item.newResp3 = item.Resp3;
      this.item.newPhase4 = item.Phase4;
      this.item.newBehavior4 = item.Behavior4;
      this.item.newResp4 = item.Resp4;
      this.item.newPhase5 = item.Phase5;
      this.item.newBehavior5 = item.Behavior5;
      this.item.newResp5 = item.Resp5;
      this.item.newPhase6 = item.Phase6;
      this.item.newBehavior6 = item.Behavior6;
      this.item.newResp6 = item.Resp6;
      this.item.newReinforce = item.Reinforce;
      this.item.newRelationship = item.Relationship;
      this.item.newRedirection = item.Redirection;
      this.item.newReadCCP = item.ReadCCP;
      this.item.newRole1 = item.Role1;
      this.item.newName1 = item.Name1;
      this.item.newRole2 = item.Role2;
      this.item.newName2 = item.Name2;
      this.item.newRole3 = item.Role3;
      this.item.newName3 = item.Name3;
      this.item.newRole4 = item.Role4;
      this.item.newName4 = item.Name4;
      this.item.newRole5 = item.Role5;
      this.item.newName5 = item.Name5;
      this.item.newRole6 = item.Role6;
      this.item.newName6 = item.Name6;
      this.item.newRole7 = item.Role7;
      this.item.newName7 = item.Name7;
      this.item.newRole8 = item.Role8;
      this.item.newName8 = item.Name8;
      this.item.newRole9 = item.Role9;
      this.item.newName9 = item.Name9;
      this.item.newRole10 = item.Role10;
      this.item.newName10 = item.Name10;
      this.item.staffName = item.Employee.Name;
      this.item.medications = item.Medications
      this.testID = item._id;

      // intializing client test data to display in windows print dialog
      this.newClientName = item.ClientName;
      this.newProgram = item.Program;
      this.newConditions = item.Conditions;
      this.newFunctions = item.Functions;
      this.newReadPCSP = item.ReadPCSP;
      this.newReadCSS = item.ReadCSS;
      this.newG1 = item.G1;
      this.newG1S1 = item.G1S1;
      this.newG1S2 = item.G1S2;
      this.newG1S3 = item.G1S3;
      this.newG1S4 = item.G1S4;
      this.newG2 = item.G2;
      this.newG2S1 = item.G2S1;
      this.newG2S2 = item.G2S2;
      this.newG2S3 = item.G2S3;
      this.newG2S4 = item.G2S4;
      this.newG3 = item.G3;
      this.newG3S1 = item.G3S1;
      this.newG3S2 = item.G3S2;
      this.newG3S3 = item.G3S3;
      this.newG3S4 = item.G3S4;
      this.newG4 = item.G4;
      this.newG4S1 = item.G4S1;
      this.newG4S2 = item.G4S2;
      this.newG4S3 = item.G4S3;
      this.newG4S4 = item.G4S4;
      this.newStrengths = item.Strengths;
      this.newPreferences = item.Preferences;
      this.newInterests = item.Interests;
      this.newRecreation = item.Recreation;
      this.newFinancial = item.Financial;
      this.newHealthConcerns = item.HealthConcerns;
      this.newPrecautions = item.Precautions;
      this.newDiet = item.Diet;
      this.newIll = item.Ill;
      this.newEating = item.Eating;
      this.newGoals = item.Goals;
      this.newMed1 = item.Med1;
      this.newPurp1 = item.Purp1;
      this.newSide1 = item.Side1;
      this.newMed2 = item.Med2;
      this.newPurp2 = item.Purp2;
      this.newSide2 = item.Side2;
      this.newMed3 = item.Med3;
      this.newPurp3 = item.Purp3;
      this.newSide3 = item.Side3;
      this.newMed4 = item.Med4;
      this.newPurp4 = item.Purp4;
      this.newSide4 = item.Side4;
      this.newMed5 = item.Med5;
      this.newPurp5 = item.Purp5;
      this.newSide5 = item.Side5;
      this.newMed6 = item.Med6;
      this.newPurp6 = item.Purp6;
      this.newSide6 = item.Side6;
      this.newMed7 = item.Med7;
      this.newPurp7 = item.Purp7;
      this.newSide7 = item.Side7;
      this.newMed8 = item.Med8;
      this.newPurp8 = item.Purp8;
      this.newSide8 = item.Side8;
      this.newMed9 = item.Med9;
      this.newPurp9 = item.Purp9;
      this.newSide9 = item.Side9;
      this.newMed10 = item.Med10;
      this.newPurp10 = item.Purp10;
      this.newSide10 = item.Side10;
      this.newMed11 = item.Med11;
      this.newPurp11 = item.Purp11;
      this.newSide11 = item.Side11;
      this.newMed12 = item.Med12;
      this.newPurp12 = item.Purp12;
      this.newSide12 = item.Side12;
      this.newMed13 = item.Med13;
      this.newPurp13 = item.Purp13;
      this.newSide13 = item.Side13;
      this.newMed14 = item.Med14;
      this.newPurp14 = item.Purp14;
      this.newSide14 = item.Side14;
      this.newMed15 = item.Med15;
      this.newPurp15 = item.Purp15;
      this.newSide15 = item.Side15;
      this.newMed16 = item.Med16;
      this.newPurp16 = item.Purp16;
      this.newSide16 = item.Side16;
      this.newMed17 = item.Med17;
      this.newPurp17 = item.Purp17;
      this.newSide17 = item.Side17;
      this.newMed18 = item.Med18;
      this.newPurp18 = item.Purp18;
      this.newSide18 = item.Side18;
      this.newMed19 = item.Med19;
      this.newPurp19 = item.Purp19;
      this.newSide19 = item.Side19;
      this.newMed20 = item.Med20;
      this.newPurp20 = item.Purp20;
      this.newSide20 = item.Side20;
      this.newReadRR = item.ReadRR;
      this.newRights = item.Rights;
      this.newSupervision = item.Supervision;
      this.newBCS = item.BCS;
      this.newReadBCS = item.ReadBCS;
      this.newTar1 = item.Tar1;
      this.newDef1 = item.Def1;
      this.newTar2 = item.Tar2;
      this.newDef2 = item.Def2;
      this.newTar3 = item.Tar3;
      this.newDef3 = item.Def3;
      this.newTar4 = item.Tar4;
      this.newDef4 = item.Def4;
      this.newTar5 = item.Tar5;
      this.newDef5 = item.Def5;
      this.newTar6 = item.Tar6;
      this.newDef6 = item.Def6;
      this.newTrig1 = item.Trig1;
      this.newTrig2 = item.Trig2;
      this.newTrig3 = item.Trig3;
      this.newTrig4 = item.Trig4;
      this.newTrig5 = item.Trig5;
      this.newTrig6 = item.Trig6;
      this.newInt1 = item.Int1;
      this.newInt2 = item.Int2;
      this.newInt3 = item.Int3;
      this.newInt4 = item.Int4;
      this.newInt5 = item.Int5;
      this.newInt6 = item.Int6;
      this.newPhase1 = item.Phase1;
      this.newBehavior1 = item.Behavior1;
      this.newResp1 = item.Resp1;
      this.newPhase2 = item.Phase2;
      this.newBehavior2 = item.Behavior2;
      this.newResp2 = item.Resp2;
      this.newPhase3 = item.Phase3;
      this.newBehavior3 = item.Behavior3;
      this.newResp3 = item.Resp3;
      this.newPhase4 = item.Phase4;
      this.newBehavior4 = item.Behavior4;
      this.newResp4 = item.Resp4;
      this.newPhase5 = item.Phase5;
      this.newBehavior5 = item.Behavior5;
      this.newResp5 = item.Resp5;
      this.newPhase6 = item.Phase6;
      this.newBehavior6 = item.Behavior6;
      this.newResp6 = item.Resp6;
      this.newReinforce = item.Reinforce;
      this.newRelationship = item.Relationship;
      this.newRedirection = item.Redirection;
      this.newReadCCP = item.ReadCCP;
      this.newRole1 = item.Role1;
      this.newName1 = item.Name1;
      this.newRole2 = item.Role2;
      this.newName2 = item.Name2;
      this.newRole3 = item.Role3;
      this.newName3 = item.Name3;
      this.newRole4 = item.Role4;
      this.newName4 = item.Name4;
      this.newRole5 = item.Role5;
      this.newName5 = item.Name5;
      this.newRole6 = item.Role6;
      this.newName6 = item.Name6;
      this.newRole7 = item.Role7;
      this.newName7 = item.Name7;
      this.newRole8 = item.Role8;
      this.newName8 = item.Name8;
      this.newRole9 = item.Role9;
      this.newName9 = item.Name9;
      this.newRole10 = item.Role10;
      this.newName10 = item.Name10;
      this.staffName = item.Employee.Name;
      this.clientId = item?.ClientId

    },
    showAdd() {
      this.titleForm = "New Client Test";
      this.newTest = true;
      this.editTest = false;
      this.draftKey = uuidv4();
    },

    deleteTest(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this client test?") &&
        this.testDelete(id);
    },

    close() {
      this.$router.push({
        path: `/ClientTest/${this.employeeID}/`,
      });
    },

    async updateTest() {
      const response = await axios.put(
        `${url}/clientTests/${this.testID}`,
        this.clientTestData()
      );

      if (response.status == 400) {
        response.json().then(function (data) {
          return alert(data.msg);
        });
      }

      this.text = "The client test has been updated successfully.";
      this.msg = true;

      this.close();
    },

    getClients: function () {
      let params = {};
      let endpoint = `${url}/clients`;
      params["Company:in"] = this.userCompanyIds;

      if (
        this.userRole !== "Administration" &&
        this.userRole !== "SuperAdministrator"
      ) {
        params["State"] = this.userState;
      }
      axios.get(endpoint, { params }).then(async (res) => {
        this.clients = res.data.clients;
      });
    },

    getUnits: function () {
      axios.get(`${url}/units`).then(async (res) => {
        this.units = res.data.units;
      });
    },

    addTest: function () {
      axios.post(`${url}/clientTests`, this.clientTestData()).then((res) => {
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.msg = true;
        this.text = "The new client test has been added successfully.";
        this.close();
      });
    },

    autoSave() {
      try {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          axios
            .post(`${url}/clientTests/draft`, this.clientTestData())
            .then((res) => {
              this.snackbar = true;
              this.snackbarMsg = "Client Test Save";
              console.log(res);
            });
        }, 5000);
      } catch (error) {
        this.snackbar = false;
        console.log(error);
      }
    },

    clientTestData() {
      return {
        Date: this.item.newDate,
        ClientName: this.item.newClientName,
        Program: this.item.newProgram,
        Conditions: this.item.newConditions,
        Functions: this.item.newFunctions,
        ReadPCSP: this.item.newReadPCSP,
        ReadCSS: this.item.newReadCSS,
        G1: this.item.newG1,
        G1S1: this.item.newG1S1,
        G1S2: this.item.newG1S2,
        G1S3: this.item.newG1S3,
        G1S4: this.item.newG1S4,
        G2: this.item.newG2,
        G2S1: this.item.newG2S1,
        G2S2: this.item.newG2S2,
        G2S3: this.item.newG2S3,
        G2S4: this.item.newG2S4,
        G3: this.item.newG3,
        G3S1: this.item.newG3S1,
        G3S2: this.item.newG3S2,
        G3S3: this.item.newG3S3,
        G3S4: this.item.newG3S4,
        G4: this.item.newG4,
        G4S1: this.item.newG4S1,
        G4S2: this.item.newG4S2,
        G4S3: this.item.newG4S3,
        G4S4: this.item.newG4S4,
        Strengths: this.item.newStrengths,
        Preferences: this.item.newPreferences,
        Interests: this.item.newInterests,
        Recreation: this.item.newRecreation,
        Financial: this.item.newFinancial,
        HealthConcerns: this.item.newHealthConcerns,
        Precautions: this.item.newPrecautions,
        Diet: this.item.newDiet,
        Ill: this.item.newIll,
        Eating: this.item.newEating,
        Goals: this.item.newGoals,
        Med1: this.item.newMed1,
        Purp1: this.item.newPurp1,
        Side1: this.item.newSide1,
        Med2: this.item.newMed2,
        Purp2: this.item.newPurp2,
        Side2: this.item.newSide2,
        Med3: this.item.newMed3,
        Purp3: this.item.newPurp3,
        Side3: this.item.newSide3,
        Med4: this.item.newMed4,
        Purp4: this.item.newPurp4,
        Side4: this.item.newSide4,
        Med5: this.item.newMed5,
        Purp5: this.item.newPurp5,
        Side5: this.item.newSide5,
        Med6: this.item.newMed6,
        Purp6: this.item.newPurp6,
        Side6: this.item.newSide6,
        Med7: this.item.newMed7,
        Purp7: this.item.newPurp7,
        Side7: this.item.newSide7,
        Med8: this.item.newMed8,
        Purp8: this.item.newPurp8,
        Side8: this.item.newSide8,
        Med9: this.item.newMed9,
        Purp9: this.item.newPurp9,
        Side9: this.item.newSide9,
        Med10: this.item.newMed10,
        Purp10: this.item.newPurp10,
        Side10: this.item.newSide10,
        Med11: this.item.newMed11,
        Purp11: this.item.newPurp11,
        Side11: this.item.newSide11,
        Med12: this.item.newMed12,
        Purp12: this.item.newPurp12,
        Side12: this.item.newSide12,
        Med13: this.item.newMed13,
        Purp13: this.item.newPurp13,
        Side13: this.item.newSide13,
        Med14: this.item.newMed14,
        Purp14: this.item.newPurp14,
        Side14: this.item.newSide14,
        Med15: this.item.newMed15,
        Purp15: this.item.newPurp15,
        Side15: this.item.newSide15,
        Med16: this.item.newMed16,
        Purp16: this.item.newPurp16,
        Side16: this.item.newSide16,
        Med17: this.item.newMed17,
        Purp17: this.item.newPurp17,
        Side17: this.item.newSide17,
        Med18: this.item.newMed18,
        Purp18: this.item.newPurp18,
        Side18: this.item.newSide18,
        Med19: this.item.newMed19,
        Purp19: this.item.newPurp19,
        Side19: this.item.newSide19,
        Med20: this.item.newMed20,
        Purp20: this.item.newPurp20,
        Side20: this.item.newSide20,
        ReadRR: this.item.newReadRR,
        Rights: this.item.newRights,
        Supervision: this.item.newSupervision,
        BCS: this.item.newBCS,
        ReadBCS: this.item.newReadBCS,
        Tar1: this.item.newTar1,
        Def1: this.item.newDef1,
        Tar2: this.item.newTar2,
        Def2: this.item.newDef2,
        Tar3: this.item.newTar3,
        Def3: this.item.newDef3,
        Tar4: this.item.newTar4,
        Def4: this.item.newDef4,
        Tar5: this.item.newTar5,
        Def5: this.item.newDef5,
        Tar6: this.item.newTar6,
        Def6: this.item.newDef6,
        Trig1: this.item.newTrig1,
        Trig2: this.item.newTrig2,
        Trig3: this.item.newTrig3,
        Trig4: this.item.newTrig4,
        Trig5: this.item.newTrig5,
        Trig6: this.item.newTrig6,
        Int1: this.item.newInt1,
        Int2: this.item.newInt2,
        Int3: this.item.newInt3,
        Int4: this.item.newInt4,
        Int5: this.item.newInt5,
        Int6: this.item.newInt6,
        Phase1: this.item.newPhase1,
        Behavior1: this.item.newBehavior1,
        Resp1: this.item.newResp1,
        Phase2: this.item.newPhase2,
        Behavior2: this.item.newBehavior2,
        Resp2: this.item.newResp2,
        Phase3: this.item.newPhase3,
        Behavior3: this.item.newBehavior3,
        Resp3: this.item.newResp3,
        Phase4: this.item.newPhase4,
        Behavior4: this.item.newBehavior4,
        Resp4: this.item.newResp4,
        Phase5: this.item.newPhase5,
        Behavior5: this.item.newBehavior5,
        Resp5: this.item.newResp5,
        Phase6: this.item.newPhase6,
        Behavior6: this.item.newBehavior6,
        Resp6: this.item.newResp6,
        Reinforce: this.item.newReinforce,
        Relationship: this.item.newRelationship,
        Redirection: this.item.newRedirection,
        ReadCCP: this.item.newReadCCP,
        Role1: this.item.newRole1,
        Name1: this.item.newName1,
        Role2: this.item.newRole2,
        Name2: this.item.newName2,
        Role3: this.item.newRole3,
        Name3: this.item.newName3,
        Role4: this.item.newRole4,
        Name4: this.item.newName4,
        Role5: this.item.newRole5,
        Name5: this.item.newName5,
        Role6: this.item.newRole6,
        Name6: this.item.newName6,
        Role7: this.item.newRole7,
        Name7: this.item.newName7,
        Role8: this.item.newRole8,
        Name8: this.item.newName8,
        Role9: this.item.newRole9,
        Name9: this.item.newName9,
        Role10: this.item.newRole10,
        Name10: this.item.newName10,
        EmployeeID: this.employeeID,
        ClientId: this.clientId,
        Medications: this.item.medications,
        Key: this.draftKey,
      };
    },

    getCompanyById() {
      axios
        .get(`${url}/companies/${this.userCompanyIds}`)
        .then((res) => {
          this.userCompany = res.data;
        })
        .catch((error) => {
          console.log(error.response.data.msg);
        });
    },

    async getClientTestItems() {
      try {
        this.isLoading = true;
        console.log(this.$route.query.id);
        const response = await axios.get(
          `${url}/clientTests/${this.$route.query.id}/item`
        );
        this.viewTest(response.data.test);
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },

    onSelectClient(clients){
      const selectedClient = clients.find(client => client.Name === this.item.newClientName);
      this.clientId = selectedClient._id
      this.fetchItems()
    },

    async fetchItems() {
      try {
        const [annualDocsResponse, medicationsResponse, behaviorsResponse, rightsResponse] = await Promise.all([
          axios.get(`${url}/annualDocs`, {
            params: { clientId: this.clientId }
          }),
          axios.get(`${url}/medications/all/${this.clientId}`, {
            params: { IsActive: true }
          }),
          axios.get(`${url}/behaviors/client/${this.clientId}`),
          axios.get(`${url}/rights/${this.clientId}`)
        ]);

        this.annualDocs = annualDocsResponse?.data?.docs?.[0] || {};
        this.annualDocsExpirationDate = DateTimeUtil.toLocalDate(this.annualDocs.DateExpires);
        this.item.medications = medicationsResponse?.data?.medications.map(({ _id, Medication }) => ({ _id, Medication })) || [];
        this.behaviors = behaviorsResponse?.data?.behaviors || [];
        this.rights = rightsResponse?.data?.rights || [];

      } catch (error) {
        console.error('Error fetching client data:', error.message);
        this.annualDocs = {};
        this.item.medications = [];
        this.behaviors = [];
        this.rights = [];
        throw new Error('Failed to fetch client data');
      }
    },

    printItem() {
      console.log("printing");
      document.getElementById("printItem").style.display = "block";
      // document.getElementsByClassName(
      //   "v-overlay__scrim"
      // )[1].style.backgroundColor = "transparent";

      window.print();

      document.getElementById("printItem").style.display = "none";
    },
  },
};
</script>
<style scoped>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

#printTable {
  display: none;
}

#printItem {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }
  #printItem {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }
  .hideOnPrint {
    display: none;
    border: none;
  }

  .outlined {
    outline-style: solid;
    outline-width: thin;
    border: 0.5px solid black;
    height: auto;
    padding: 5px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
